var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.986879 12.9545H14.0131C14.7736 12.9545 15.2397 12.1632 14.8717 11.5158L8.34634 0.485571C7.97836 -0.161857 7.02163 -0.161857 6.65366 0.485571L0.128275 11.5158C-0.239698 12.1393 0.226402 12.9545 0.986879 12.9545ZM7.48773 3.89056C7.90477 3.89056 8.24821 4.22626 8.22368 4.6339L8.10102 8.83019C8.10102 9.16589 7.80664 9.42966 7.48773 9.42966C7.14429 9.42966 6.87445 9.16589 6.87445 8.83019L6.75179 4.6339C6.75179 4.22626 7.0707 3.89056 7.48773 3.89056ZM7.48773 9.93322C7.90477 9.93322 8.24821 10.2689 8.24821 10.6766C8.24821 11.0842 7.90477 11.4199 7.48773 11.4199C7.0707 11.4199 6.72726 11.0842 6.72726 10.6766C6.72726 10.2929 7.0707 9.93322 7.48773 9.93322Z",
    fill: "#F17413"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.fcd6da24.svg";
export { ForwardRef as ReactComponent };